import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import Component from '../Component';
/**
 * @see https://aframe.io/docs/1.3.0/components/gltf-model.html#scene-properties
 */

export var GLTFModel = /*#__PURE__*/function (_Component) {
  _inheritsLoose(GLTFModel, _Component);

  function GLTFModel() {
    return _Component.apply(this, arguments) || this;
  }

  return GLTFModel;
}(Component);